import TaskFilters from "../../interfaces/task/TaskFilters";

// TaskPdfService.ts

export async function getTasksPdf(
    authToken: string,
    userId?: string,
    filters?: TaskFilters | null,
    sortBy: string = "",
    sortDesc: boolean = false,
): Promise<Blob | null> {
    try {
        const queryParams = new URLSearchParams({
            sortBy: sortBy,
            sortDesc: sortDesc.toString()
        });

        if (filters) {
            if (filters.searchTerm) {
                queryParams.set("searchTerm", filters.searchTerm);
            }
            if (filters.status && filters.status.length > 0) {
                filters.status.forEach((s) => queryParams.append("status", s));
            }
            if (filters.type && filters.type.length > 0) {
                filters.type.forEach((t) => queryParams.append("type", t));
            }
            if (filters.date && filters.date.length > 0) {
                filters.date.forEach((d) => queryParams.append("date", d));
            }
            if (filters.assignees && filters.assignees.length > 0) {
                filters.assignees.forEach((a) => queryParams.append("assignee", a));
            }
            if (filters.participants && filters.participants.length > 0) {
                filters.participants.forEach((p) =>
                    queryParams.append("participant", p)
                );
            }
            if (filters.tags && filters.tags.length > 0) {
                filters.tags.forEach((t) => queryParams.append("tags", t));
            }
            if (filters.excludeTags && filters.excludeTags.length > 0) {
                filters.excludeTags.forEach((t) => queryParams.append("excludeTags", t));
            }
            if (filters.excludeDate && filters.excludeDate.length > 0) {
                filters.excludeDate.forEach((d) => queryParams.append("excludeDate", d));
            }
            if (filters.excludeStatus && filters.excludeStatus.length > 0) {
                filters.excludeStatus.forEach((s) => queryParams.append("excludeStatus", s));
            }
            if (filters.excludeType && filters.excludeType.length > 0) {
                filters.excludeType.forEach((t) => queryParams.append("excludeType", t));
            }
            if (filters.viewAll !== undefined) {
                queryParams.set("viewAll", filters.viewAll.toString());
            }
        }

        console.log('Query Params', queryParams.toString())
        let apiUrl: string;
        if (userId) {
            apiUrl = `${process.env.REACT_APP_API_BASE_URL}/tasks/user/${userId}/pdf?${queryParams.toString()}`; // I believe that this endpoint doesn't exist? 
            console.log('Calling Task PDF Generation for specific user?')
        } else {
            apiUrl = `${process.env.REACT_APP_API_BASE_URL}/tasks/pdf?${queryParams.toString()}`;
            console.log('Calling Task PDF Generation for self?')
        }

        const response = await fetch(apiUrl, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            return null;
        }

        const pdfBlob = await response.blob();
        return pdfBlob;

    } catch (error) {
        console.error("Error fetching tasks PDF:", error);
        return null;
    }
}
